import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";

import styles from "./Expandable.module.scss";

interface ExpandableProps {
  open?: boolean;
  className?: string;
  innerClassName?: string;
}

const Expandable: React.FC<ExpandableProps> = ({
  open,
  children,
  className,
  innerClassName,
}) => {
  const [internalOpen, setInternalOpen] = useState(open);
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!outerRef.current || !innerRef.current) {
      return;
    }

    if (internalOpen !== open) {
      const { height: firstHeight } = outerRef.current.getBoundingClientRect();
      outerRef.current.classList.toggle(styles.open, open);
      const { height: lastHeight } = outerRef.current.getBoundingClientRect();

      const anim = outerRef.current.animate(
        [
          {
            height: `${firstHeight}px`,
          },
          {
            height: `${lastHeight}px`,
          },
        ],
        {
          duration: 300,
          easing: "ease-in-out",
          fill: "both",
        }
      );
      anim.onfinish = () => {
        anim.cancel();
        setInternalOpen(open);
      };
    }
  }, [internalOpen, open]);

  return (
    <div
      ref={outerRef}
      className={classNames(
        styles.outer,
        { [styles.open]: internalOpen },
        className
      )}
    >
      <div ref={innerRef} className={classNames(styles.inner, innerClassName)}>
        {children}
      </div>
    </div>
  );
};

export { Expandable };
